module.exports = __webpack_public_path__ + "static/media/app3.a44148df.jpeg";